module.exports = __webpack_public_path__ + "media/assets/fonts/Gobold-Light-1de215f79224f1f887c3a01129e25258.otf";